import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import uiDux from 'src/redux/ui';
import 'pepjs';

const SaveDesignButtonContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
`;

export const Button = styled.button`
  font-size: 13px;
  margin-bottom: 0;
  padding: 10px 12px;
  line-height: 12px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.defaultActionBlue};
  border-radius: 2px;
  box-shadow: inset 0px -1px 0px 0px rgba(0, 0, 0, 0.04);

  &:focus {
    background-color: ${({ theme }) => theme.colors.defaultActionBlue};
  }
  &:hover {
    background-color: ${({ theme }) => theme.colors.darkActionBlue};
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const mapStateToProps = (state) => ({
  shouldRender: uiDux.selectors.shouldRenderSaveDesignButton(state),
});

export const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      handleSaveDesignButtonClick: uiDux.actions.handleSaveDesignButtonClick,
    },
    dispatch,
  );

export class SaveDesignButton extends PureComponent {
  static propTypes = {
    handleSaveDesignButtonClick: PropTypes.func.isRequired,
    shouldRender: PropTypes.bool.isRequired,
  };

  render() {
    const { handleSaveDesignButtonClick, shouldRender } = this.props;

    return shouldRender ? (
      <SaveDesignButtonContainer>
        <div touch-action="none">
          {/* Prevent zoom on touch devices. Also note, touch-action is incompatible with styled and React components (see NS-947) */}
          <Button
            onClick={handleSaveDesignButtonClick}
            data-selenium="saveButton"
          >
            Save
          </Button>
        </div>
      </SaveDesignButtonContainer>
    ) : null;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SaveDesignButton);
